import { IEntity } from '@pf/shared-common';
import {
    ExceptionCauseTypeFragment,
    ExceptionEntitySearchRequestParams,
    ExceptionPriority,
    ExceptionStatus,
    ExceptionTypeFragment,
    ExceptionViewModelCreateBody,
    ExceptionViewModelRead,
    InventoryBundleFragment,
    ItemFragment,
    ResolutionTypeFragment,
    ResourceAuth,
    SlotFragment,
    UserFragment,
    WarehouseFragment,
    WmsPlatformEntity,
} from '@control-tower/platform-wms';
import {
    CustomFieldDto,
    ICustomFieldDto,
    NoteDto,
} from '@pf/shared/util-platform';
import { IWarehouseEntity } from '../interfaces/warehouse-entity';
import { mapToClassSafe } from '@pf/shared-utility';

export type ExceptionRead = ExceptionViewModelRead & IEntity;
export type ExceptionCreate = ExceptionViewModelCreateBody;
export type ExceptionSearchParams = ExceptionEntitySearchRequestParams;

export class ExceptionDto implements IWarehouseEntity {
    constructor(data: Partial<ExceptionDto>) {
        Object.assign(this, data);
        this.notes = data.notes
            ? mapToClassSafe(data.notes, NoteDto)
            : undefined;
        this.resolutionNotes = data.resolutionNotes
            ? mapToClassSafe(data.resolutionNotes, NoteDto)
            : undefined;
        this.customFields = mapToClassSafe(data.customFields, CustomFieldDto);
    }
    id!: string;
    sourceEntity!: WmsPlatformEntity;
    sourceEntityId!: string;
    warehouse!: WarehouseFragment;
    source!: IEntity;

    status?: ExceptionStatus;
    priority?: ExceptionPriority;
    resolvedDateTime?: string | null;
    notes?: NoteDto[] | null;
    expectedQuantity?: number | null;
    actualQuantity?: number | null;
    affectedQuantity?: number | null;
    resolutionNotes?: NoteDto[] | null;
    resourceAuth?: ResourceAuth;
    exceptionType?: ExceptionTypeFragment;
    exceptionCauseType?: ExceptionCauseTypeFragment;
    resolutionType?: ResolutionTypeFragment;
    slot?: SlotFragment;
    item?: ItemFragment;
    inventoryBundle?: InventoryBundleFragment;
    assignedToUser?: UserFragment;
    approvedByUser?: UserFragment;
    customFields?: Array<ICustomFieldDto> | null;

    isDeleted?: boolean;
    createdDate?: string;
    modifiedDate?: string;
}
